import { swup } from '../main';

/**
 * Sets up a click event
 */
export function setupMenuTrigger()
{
	let body = $('body');

	$('.menu-trigger').on('click', function (e){
		e.preventDefault();
		if(body.hasClass('menu-active'))
		{
			body.removeClass('menu-active');
		}
		else
		{
			body.addClass('menu-active');
		}
	});

	
	swup.on('samePage', function() {
		if(body.hasClass('menu-active'))
		{
			body.removeClass('menu-active');
		}
	});

}

/**
 * Updates the menu based on the current url
 */
export function updateMenu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;

	//Remove the old current page attributes
	let current_page = $('.nav li.current-menu-item');
	current_page.removeClass('current-menu-item').find('a').attr('aria-current', '');

	//Find the new current page and add classes
	let active_items = $('.nav').find('a[href="' + url + '"]');
	active_items.each(function(){
		$(this).attr('aria-current', 'page');
		$(this).parent().addClass('current-menu-item');
	});
}

export function setupFooterToggle()
{
	let signupToggle = document.querySelector('.footer-signup__toggle');

	if(!signupToggle) {
		return;
	}

	let parent = signupToggle.parentNode;

	signupToggle.addEventListener('click', () => {
		parent.classList.add('form-active');
	})
}

/**
 * Sets up the scrolled class
 */
export function setupScrolling()
{
	var lastScrollTop = 0;

	window.addEventListener('scroll', function()
	{
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > 0)
		{
			document.body.classList.add('scrolled');

			if (scrollTop > window.innerHeight + 20)
			{
				document.body.classList.add('window-scrolled');
			}
			else
			{
				document.body.classList.remove('window-scrolled');
			}

			if (scrollTop > lastScrollTop){
				document.body.classList.remove('scrolled-up');
				document.body.classList.add('scrolled-down');
			}
			else
			{
				document.body.classList.remove('scrolled-down');
				document.body.classList.add('scrolled-up');
			}
		}
		else
		{
			document.body.classList.remove(
				'scrolled',
				'scrolled-down',
				'scrolled-up' ,
				'window-scrolled'
			);
		}

		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
	}, false);
}

export function setupMobileViewport()
{
	const setViewportHeight = () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	window.addEventListener('resize', () => {
		setViewportHeight();
	});

	setViewportHeight();
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js